/**
 * DarkOverlay for the main wrapper toggler
 */
export function showOverlay() {
  document.querySelector('.js-main').classList.add('main--overlay-dark', 'js-navigation-overlay');
  document.querySelectorAll('.js-footer').forEach((el) => el.classList.add('footer--overlay-dark', 'js-navigation-overlay'));
}

export function hideOverlay() {
  document.querySelector('.js-main').classList.remove('main--overlay-dark', 'js-navigation-overlay');
  document.querySelectorAll('.js-footer').forEach((el) => el.classList.remove('footer--overlay-dark', 'js-navigation-overlay'));
}
